import { Component, EventEmitter, Input, OnInit, Output, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CrSyncService } from 'app/services/crsync.service';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { throttleTime } from 'rxjs/operators';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-cr-notes-form',
    templateUrl: './cr-notes-form.component.html',
    styles: [],
    changeDetection: ChangeDetectionStrategy.Default,
    imports: [FormsModule, ReactiveFormsModule, TranslateModule]
})
export class CrNotesFormComponent implements OnInit, OnDestroy {

  constructor(
    private fb: UntypedFormBuilder,
    private crSync: CrSyncService
  ) { }

  @Input() addedCameraVisitNotes: string[];
  @Input() alert;
  @Input() noteText: string;
  @Output() noteTextKeeped = new EventEmitter<string>();

  noteForm: UntypedFormGroup;
  @Output() onCloseByCancel = new EventEmitter<any>();

  formSubmitSubject = new Subject<void>();

  noteTextSubject = new BehaviorSubject<string>("");

  createNoteForm(): void {
    this.noteForm = this.fb.group({
      text: [this.noteText, Validators.required]
    })
  }

  closeForm(): void {
    this.onCloseByCancel.emit();
  }

  submitNote(): void {
    this.attachNoteToAlert(this.noteForm.value.text)
  }

  attachNoteToAlert(text: string){
    if (this.alert) {
      this.crSync.addNote(this.alert.userId, this.alert.alertId, text);
      this.alert.noteCache = "";
    } else {
      this.addedCameraVisitNotes.push(text)
    }
  }

  noteKeeper(): void {
    this.noteTextKeeped.emit(this.noteForm.value.text);
  }

  ngOnInit() {
    this.createNoteForm();

    // Initialize form submit subject with 3 second throttle time to prevent multiple submits
    this.formSubmitSubject.pipe(throttleTime(3000))
    .subscribe(() => {
      this.submitNote();
    });
  }

  ngOnDestroy(): void {
    this.formSubmitSubject.unsubscribe();
  }

}
